module.exports = new __parcel__URL__("amp-map.5f4d399a.svg").toString();